import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { MaintenanceService } from '@shared/service/maintenance.service';

/** Blocks every feature route while maintenance mode is active, redirecting to the stub page. */
export const MaintenanceGuard: CanActivateFn = () => {
  const _maintenance = inject(MaintenanceService);
  const _r = inject(Router);

  if (_maintenance.isActive()) {
    _r.navigate(['/maintenance']);
    return of(false);
  }
  return of(true);
};

/** Keeps the maintenance stub reachable only while maintenance mode is active. */
export const MaintenanceInactiveGuard: CanActivateFn = () => {
  const _maintenance = inject(MaintenanceService);
  const _r = inject(Router);

  if (_maintenance.isActive()) {
    return of(true);
  }
  _r.navigate(['/']);
  return of(false);
};
